// Skickar custom event till Plausible. Säkert om scriptet inte laddats.
import i18n from "@/i18n";

declare global {
  interface Window {
    plausible?: (event: string, options?: { props?: Record<string, string | number | boolean> }) => void;
  }
}

export function track(event: string, props?: Record<string, string | number | boolean>) {
  if (typeof window === "undefined") return;
  try {
    // Injicera språk-dimension på alla events så vi kan filtrera konvertering per språk.
    const lang = (i18n.language || "sv").slice(0, 5);
    const merged = { lang, ...(props ?? {}) };
    window.plausible?.(event, { props: merged });
  } catch {
    /* ignore */
  }
}
